import { db, storage } from '@/firebase'
import { mostrarIdioma } from '@/utils/utils'

export default {
  getTickets({ commit, rootState }) {
    let negocio = rootState.app.negocioGest;
    let devolver = [];
    return db.collection('negocios').doc(negocio).collection('tickets').get()
      .then((res) => {
        res.forEach(doc => {
          let aux = doc.data();
          aux.id = doc.id;
          devolver.push(aux);
        });
        commit('setTicketsArray', devolver);
        return devolver;
      })
  },
  addTicket({ rootGetters, rootState }, t) {
    let negocio = rootState.app.negocioGest;
    let id = t.id;
    let imagen = t.imagen
    delete t.id;
    delete t.imagen;
    var ref = null;
    var refDB = null;
    if (id) {
      ref = db.collection('negocios').doc(negocio).collection('tickets').doc(id).set(t, { merge: true })
    } else {
      ref = db.collection('negocios').doc(negocio).collection('tickets').add(t)
    }
    if (imagen) {
      return ref
        .then((res) => {
          if (!id) {
            id = res.id;
          }
          var storageRef = storage.ref();
          var ref = storageRef.child('negocios/' + negocio + '/tickets/' + id + '.jpg');
          return ref.put(imagen);
        })
        .then((r) => {
          return r.ref.getDownloadURL()
        })
        .then((url) => {
          return db.collection('negocios').doc(negocio).collection('tickets').doc(id).set({
            logo: url
          }, { merge: true })
        })
        .catch((e) => console.log(e))
    } else {
      return ref
        .then((res) => {
          if (!id) {
            id = res.id;
          }
          return db.collection('negocios').doc(negocio).collection('tickets').doc(id).set({
            logo: null
          }, { merge: true })
        })
    }

  },

  deleteTicket({ rootState }, item) {
    let negocio = rootState.app.negocioGest;
    return db.collection('negocios').doc(negocio).collection('tickets').doc(item.id).delete()
  },
  traerReglasEscrituraMapeo({ rootState }) {
    let negocio = rootState.app.negocioGest;
    var prdsNeo;
    var prdsMewo;
    var reglasDevolver = [];
    if (rootState.app.negocioObjGest.mapeoNeoRestaurante) {//centralizado
      return Promise.all([
        db.collection('negocios').doc(negocio).collection('secreto').doc('neo').get()
          .then((r) => {
            if (r.exists) {
              prdsNeo = r.data().productos;
            } else {
              return Promise.reject('neo/sin-productos')
            }
          }),
        db.collection('negocios').doc(negocio).collection('productos').get()
          .then((r) => {
            if (!r.empty) {
              prdsMewo = r.docs.map(p => {
                return {
                  ...p.data(),
                  id: p.id
                }
              })
            } else {
              return Promise.reject('neo/sin-productos')
            }
          })
      ])
        .then(() => {
          prdsMewo.forEach(pMewo => {
            const mapeoNeo = pMewo.mapeoNeo;
            var foundNeo = prdsNeo.find(pNeo => pNeo.Codigo == mapeoNeo);
            if (foundNeo) {
              reglasDevolver.push({
                antes: mostrarIdioma(pMewo.nombre).trim(),
                despues: foundNeo.Nombre.trim()
              })
              if (pMewo.opciones && Array.isArray(pMewo.opciones)) {
                //primero tomamos todas las opciones Neo y la metemos en un array
                let elementosFlat = [];
                if (Array.isArray(foundNeo.Elementos)) {
                  foundNeo.Elementos.forEach((elem) => {
                    elementosFlat = [...elementosFlat, ...elem.Opciones]
                  })
                }
                //recorremos las opciones y buscamos en general y luego en los elementos Neo
                pMewo.opciones.forEach(panel => {
                  panel.opciones.forEach(op => {
                    if (op.mapeoNeo) {
                      let foundOpGeneral = prdsNeo.find((p) => p.Codigo == op.mapeoNeo);
                      let foundOpProducto = elementosFlat.find((el) => el.Componente == op.mapeoNeo);
                      if (foundOpGeneral) {
                        reglasDevolver.push({
                          antes: mostrarIdioma(op.title).trim(),
                          despues: foundOpGeneral.Nombre.trim()
                        })
                      } else if (foundOpProducto) {
                        reglasDevolver.push({
                          antes: mostrarIdioma(op.title).trim(),
                          despues: foundOpProducto.NombreComponente.trim()
                        })
                      }
                    }
                  })
                })
              }
            }
          })
          return reglasDevolver;
        })
    } else { //no centralizado
      return Promise.all(
        rootState.restaurantes.restaurantesArray.map(r => {
          console.log(r.id);
          return Promise.all([
            db.collection('restaurantes').doc(r.id).collection('secreto').doc('neo').get(),
            db.collection('restaurantes').doc(r.id).get(),
            db.collection('negocios').doc(negocio).collection('productos').get()
              .then((r) => {
                if (!r.empty) {
                  return r.docs.map(p => {
                    return {
                      ...p.data(),
                      id: p.id
                    }
                  })
                }
              })
          ])
            .then(r => {
              var restData = r[1].data();
              var restDataProductosAsociados = restData.productosAsociados;
              var restDataProductosMapeados = restData.productosMapeados;
              var restPrdNeo = r[0].data().productos;
              var prdMewo = r[2];
              // console.log(restDataProductosMapeados);
              // console.log(restDataProductosAsociados);
              // console.log(restPrdNeo);
              restDataProductosAsociados.forEach(pMewo => {
                var foundMapeo = restDataProductosMapeados ? restDataProductosMapeados.find(p => p.id == pMewo.id) : null
                var codigoMapeo = foundMapeo ? foundMapeo.mapeoRest : null;
                var foundNeo = restPrdNeo.find(pNeo => pNeo.Codigo == codigoMapeo);
                var foundGeneral = prdMewo.find(p => p.id == pMewo.id);
                if (foundNeo && foundGeneral) {
                  reglasDevolver.push({
                    antes: mostrarIdioma(foundGeneral.nombre).trim(),
                    despues: foundNeo.Nombre.trim()
                  })
                  if (pMewo.opciones && Array.isArray(pMewo.opciones) && foundGeneral && Array.isArray(foundGeneral.opciones)) {
                    //primero tomamos todas las opciones Neo y la metemos en un array
                    let elementosFlat = [];
                    if (Array.isArray(foundNeo.Elementos)) {
                      foundNeo.Elementos.forEach((elem) => {
                        elementosFlat = [...elementosFlat, ...elem.Opciones]
                      })
                    }
                    //recorremos las opciones y buscamos en general y luego en los elementos Neo
                    foundGeneral.opciones.forEach(panel => {
                      console.log(panel)
                      panel.opciones.forEach(op => {
                        let foundOpMapeoRest = foundMapeo && foundMapeo.opciones ? foundMapeo.opciones.find(fmOp => fmOp.id == op.id) : null
                        if (foundOpMapeoRest) {
                          let foundOpGeneral = restPrdNeo.find((p) => p.Codigo == foundOpMapeoRest.mapeoRest);
                          let foundOpProducto = elementosFlat.find((el) => el.Componente == foundOpMapeoRest.mapeoRest);
                          if (foundOpGeneral) {
                            reglasDevolver.push({
                              antes: mostrarIdioma(op.title).trim(),
                              despues: foundOpGeneral.Nombre.trim()
                            })
                          } else if (foundOpProducto) {
                            reglasDevolver.push({
                              antes: mostrarIdioma(op.title).trim(),
                              despues: foundOpProducto.NombreComponente.trim()
                            })
                          }
                        }
                      })
                    })
                  }
                }

              })
            })
        })
      )
        .then(res => {
          return reglasDevolver;
          // console.log(res);
          // var prdAux = []
          // res.forEach(p => {
          //   if (p.exists)
          //     prdAux = [...prdAux, ...p.data().productos]
          // })
          // return prdAux
        })
        .catch(e => console.log(e))
    }

  }
}